import { takeLatest, put, call, select } from 'redux-saga/effects';
import requext from '../../utils/requext';

import { getAuthInfo } from '../selectors';
import * as actionTypes from '../actionTypes';

function* socialLogin({ payload }) {
    const { provider, ...rest } = payload;
    if (provider !== 'facebook') return;

    try {
        const query = {
            query: `mutation loginWithFB($accessToken: String!, $userId: String!) {
                loginWithFB(accessToken: $accessToken, userId: $userId) {
                    token
                    success
                    message 
                    user {
                        id
                        name
                        avatar
                        email
                    }
                }
            }`,
            variables: rest,
        };
        const resp = yield requext(undefined, JSON.stringify(query));
        const { data } = yield resp.json();
        if (data && data.loginWithFB && data.loginWithFB.success) {
            yield put({
                type: actionTypes.LOGIN_SUCCESS,
                payload: data.loginWithFB,
            });
        } else {
            const payload = {
                message: data
                    ? data.loginWithFB
                        ? data.loginWithFB.message
                        : 'Login failed'
                    : 'Login failed',
            };
            yield put({ type: actionTypes.LOGIN_FAILED, payload });
        }
    } catch (err) {}
}

function* logout() {
    try {
        const query = {
            query: `mutation {
                logout
            }`,
        };
        const resp = yield requext(undefined, JSON.stringify(query));
        const { data } = yield resp.json();
        if (data && data.logout) {
            yield put({ type: actionTypes.LOGOUT_USER_SUCCESS });
        } else {
            yield put({ type: actionTypes.LOGOUT_USER_FAILURE });
        }
    } catch (err) {
        console.log(err);
    }
}

export function* refreshAccessToken() {
    try {
        const query = {
            query: `mutation {
                refreshToken {
                    token
                    success
                    expiresAt
                    user {
                        id
                        roles
                    }
                }
            }`,
        };
        const resp = yield requext(undefined, JSON.stringify(query));
        const { data } = yield resp.json();
        if (data?.refreshToken?.success) {
            yield put({
                type: actionTypes.REFRESH_AT_SUCCESS,
                payload: data.refreshToken,
            });
        } else {
            yield put({ type: actionTypes.REFRESH_AT_FAILURE });
        }
    } catch (err) {
        console.log(err);
    }
}

function* checkAuth({ payload }) {
    try {
        const { expiresAt = 0 } = yield select(getAuthInfo);
        if (expiresAt * 1000 < Date.now()) {
            yield call(refreshAccessToken);
        }
        yield put(payload);
    } catch (e) {
        yield put({ type: actionTypes.REFRESH_AT_FAILURE });
    }
}

export default [
    takeLatest(actionTypes.CHECK_AUTH, checkAuth),
    takeLatest(actionTypes.LOGOUT_USER_REQUEST, logout),
    takeLatest(actionTypes.SOCIAL_LOGIN_REQUEST, socialLogin),
    takeLatest(actionTypes.REFRESH_AT_REQUEST, refreshAccessToken),
];
